module.exports = __webpack_public_path__ + "media/images/icons/trustpilot-star-d1fba4b230028688ffbdab9b8178d201.svg";